module.exports = __webpack_public_path__ + "static/sanofi-logo-fr-5f352a78b659511ea540f4d3651b1075.jpg";